/**
 * Iter 152 · Indicador de vencimientos documentales en topbar.
 *
 * Muestra un badge con docs caducados + próximos a caducar (≤15d).
 * Doble nivel de aviso:
 *   - Rojo si hay caducados o avisos de 5 días.
 *   - Ámbar si solo hay avisos de 15 días.
 *
 * Usa /api/checklist/badge/vencimientos y refresca cada 5 min.
 */
import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { AlertOctagon } from "lucide-react";
import api from "@/lib/api";

export default function VencimientosDocBadge() {
  const [data, setData] = useState({ total: 0, caducados: [], aviso_5d: [], aviso_15d: [] });

  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/checklist/badge/vencimientos");
      setData(d || { total: 0, caducados: [], aviso_5d: [], aviso_15d: [] });
    } catch (_) { /* silent */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [load]);

  const total = data.total || 0;
  const criticos = (data.caducados?.length || 0) + (data.aviso_5d?.length || 0);
  const tip = total
    ? `${data.caducados?.length || 0} caducados · ${data.aviso_5d?.length || 0} a ≤5 días · ${data.aviso_15d?.length || 0} a ≤15 días`
    : "Sin vencimientos documentales próximos";
  const color = criticos > 0 ? "#DC2626" : (total > 0 ? "#E08A1F" : null);

  return (
    <Link
      to="/documentacion-empresa"
      title={tip}
      data-testid="vencimientos-doc-indicator"
      className="relative inline-flex items-center justify-center h-9 w-9 rounded-full hover:bg-black/[0.05] dark:hover:bg-white/[0.06] text-[var(--legatum-text-muted)] hover:text-[var(--legatum-text)] transition-colors"
    >
      <AlertOctagon className="h-4 w-4" />
      {total > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold flex items-center justify-center"
          style={{ background: color, color: "#fff" }}
          data-testid="vencimientos-doc-badge"
        >
          {total > 99 ? "99+" : total}
        </span>
      )}
    </Link>
  );
}
